// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ghY5","content":"styles_content__6rB_r"};